function unsafeFilter($sce) {
  return $sce.trustAsHtml;
}

unsafeFilter.$inject = ['$sce'];

export default unsafeFilter;



/** WEBPACK FOOTER **
 ** ./src/app/filters/unsafe.filter.js
 **/